import React from 'react';
import OrderLoader from 'src/components/OrderLoader';

type Props = {
  showPopup: boolean;
};

export const ProcessingOverlay = ({ showPopup }: Props) =>
  showPopup && <OrderLoader />;
